<template>
  <div>
    <b-modal
      v-if="isTransactionModalOpen"
      v-model="isTransactionModalOpen"
      size="xl"
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      modal-class="transaction-account-modal"
      header-class="transaction-modal-header"
      body-class="transaction-account-modal-body"
      footer-class="transaction-account-modal-footer"
    >
      <template #modal-header>
        <div class="w-100">
          <div class="d-flex align-items-start">
            <div class="flex-grow-1">
              <div v-if="transaction.general.id == null">
                <div class="transaction-modal-title" style="font-size: 20px">
                  Nova Conta
                </div>
                <div class="transaction-modal-description">
                  Digite as informações solicitadas para adicionar uma nova
                  conta.
                </div>
              </div>

              <div v-else>
                <div class="transaction-modal-title">
                  Conta #<b>{{ transaction.general.id }}</b>
                </div>
                <!-- <b-col align-h="end">
              <div @click.prevent="confirmTransmission" :disabled="changedTransaction" :class="`btn btn-outline-primary btn-sm  ${changedTransaction ? 'disabled' : ''}`">
                Transmitir
              </div>
            </b-col> -->
              </div>

              <!-- <b-col class="text-right" align-h="end">
            <b-form-checkbox v-model="transaction.general.open" :disabled="true" name="check-button" switch @input="checkCloseTransaction()">
              Conta {{ transaction.general.open ? 'aberta' : 'fechada' }}
            </b-form-checkbox>
          </b-col> -->
            </div>

            <div class="transaction-modal-header-meta">
              <button
                type="button"
                class="close transaction-modal-close"
                aria-label="Close"
                @click.prevent="closeTransactionModal()"
              >
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.5 1.5L16.5 16.5"
                    stroke="#8D8D8D"
                    stroke-width="3"
                    stroke-linecap="round"
                  />
                  <path
                    d="M16.5 1.5L1.5 16.5"
                    stroke="#8D8D8D"
                    stroke-width="3"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
            </div>
          </div>

          <div
            class="transaction-modal-import"
            v-click-outside="closeQuoteDropdown"
          >
            <div class="transaction-modal-import-search">
              <div class="transaction-modal-import-field">
                <i class="fas fa-search"></i>
                <input
                  v-model="quoteSearch"
                  type="text"
                  placeholder="importar cotação"
                  @focus="openQuoteDropdown"
                  @input="openQuoteDropdown"
                />
              </div>

              <div
                v-if="quoteDropdownOpen"
                class="transaction-modal-quote-list"
              >
                <div v-if="quoteLoading" class="transaction-modal-quote-empty">
                  Carregando reservas...
                </div>
                <div
                  v-else-if="filteredQuoteLeads.length == 0"
                  class="transaction-modal-quote-empty"
                >
                  Nenhuma reserva encontrada.
                </div>
                <template v-else>
                  <button
                    v-for="lead in filteredQuoteLeads"
                    :key="lead.hash"
                    type="button"
                    class="transaction-modal-quote-card"
                    @click="selectQuoteLead(lead)"
                  >
                    <div class="transaction-modal-quote-card-top">
                      <span class="transaction-modal-quote-code"
                        >#{{ lead.booking_code }}</span
                      >
                      <b-badge
                        :variant="quoteStatusVariant(lead.status)"
                        class="ml-2"
                        >{{ lead.status }}</b-badge
                      >
                      <strong class="ml-auto">{{
                        formatQuoteCurrency(getQuoteLeadTotal(lead))
                      }}</strong>
                    </div>
                    <div class="transaction-modal-quote-title">
                      {{
                        lead.items && lead.items[0]
                          ? lead.items[0].title
                          : 'Passeio'
                      }}
                    </div>
                    <div class="transaction-modal-quote-meta">
                      {{ quoteResponsibleLabel(lead) }}
                    </div>
                    <div class="transaction-modal-quote-meta">
                      {{ lead.product_place }}
                      <span v-if="lead.date">
                        · {{ formatQuoteDate(lead.date) }}</span
                      >
                      <span v-if="lead.time"> · {{ lead.time }}</span>
                    </div>
                  </button>
                </template>
              </div>
            </div>
            <button v-if="false"
              type="button"
              class="transaction-modal-see-all"
              @click="openImportBookingModal"
            >
              ver tudo
            </button>
          </div>
        </div>
      </template>

      <modal-loading
        :openModal="isLoading"
        :value="'100'"
        :label="'carregando... '"
        :variant="'white'"
        :animated="false"
      >
      </modal-loading>

      <transaction-form
        :key="formKey"
        ref="transactionForm"
        :changedTransaction="changedTransaction"
        @emitDisabledSaveButton="handleDisabledSaveButton"
        @emitTransactionHasChanged="transactionHasChanged"
        @emitSaveTransaction="saveTransaction($event.id, $event.reopenTransactionID)"
        :currentTransactionID="currentTransactionID"
      >
      </transaction-form>

      <template #modal-footer>
        <div class="w-100">
          <div class="modal-add-footer">
            <div class="d-flex w-100">
              <div
                @click.prevent="confirmDelete"
                :disabled="closedTransaction"
                :class="`btn btn-outline-danger btn-sm  ${
                  closedTransaction ? 'disabled' : ''
                }`"
              >
                <i
                  class="fas fa-trash fa-lg ml-2 mr-2 mt-2 mb-2"
                  style="font-size: 1.5rem"
                ></i>
              </div>

              <div
                @click.prevent="closeTransactionModal()"
                class="btn btn-outline-danger w-100"
                style="padding-top: 9px"
              >
                CANCELAR
              </div>

              <div
                @click.prevent="saveTransaction(transaction.general.id, null)"
                :disabled="disabledSaveButton || !changedTransaction"
                style="padding-top: 9px"
                :class="`btn btn-back w-100 ${
                  disabledSaveButton || !changedTransaction ? 'disabled' : ''
                }`"
              >
                SALVAR
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ModalLoading from '../../components/ModalLoading/ModalLoading.vue'
import TransactionForm from './TransactionForm.vue'
import { mapActions, mapGetters } from 'vuex'
import swal from 'sweetalert2'
import moment from 'moment'
import nodeService from '@/services/nodejs'

export default {
  name: 'TransactionModal',

  components: {
    TransactionForm,
    ModalLoading,
  },

  props: {
    currentTransactionID: {
      type: [Number, String],
      default: null,
    },
    isTransactionModalOpen: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters('financeiro', {
      transaction: 'getInputTransaction',
    }),

    ...mapGetters('auth', {
      place: 'getPlace',
    }),

    closedTransaction() {
      return !this.transaction.general.open
    },

    filteredQuoteLeads() {
      const query = (this.quoteSearch || '').toLowerCase().trim()
      let leads = this.quoteLeads
      if (query) {
        leads = leads.filter((lead) =>
          (lead.searchText || '').toLowerCase().includes(query)
        )
      }
      return leads.slice(0, 8)
    },
  },

  watch: {
    ['transaction.general.open'](newValue, oldValue) {
      if (newValue != oldValue) {
        this.transaction.general.bill_status = newValue ? 'PENDING' : 'PAID'
      }
    },

    currentTransactionID(newValue, oldValue) {
      if (newValue == oldValue) return
      this.formKey += 1
    },
  },

  data() {
    return {
      disabledSaveButton: false,
      changedTransaction: false,
      localStored_transaction: {},
      isLoading: false,
      formKey: 0,
      quoteSearch: '',
      quoteLeads: [],
      quoteLoading: false,
      quoteDropdownOpen: false,
    }
  },

  methods: {
    ...mapActions('product', ['fetchPOIs']),

    ...mapActions('financeiro', [
      'createTransaction',
      'deleteTransaction',
      'closeTransaction',
      'sendTransaction',
    ]),

    async saveTransaction(id, reopenTransactionID) {
      console.log('saveTransaction', this.transaction, id, reopenTransactionID)
      if (!this.disabledSaveButton && this.changedTransaction) {
        let validatedForm = true
        this.transaction.products.forEach((product, index) => {
          if (
            !this.transaction.products[index].item.uuid &&
            !this.transaction.products[index].removed
          ) {
            this.$notify({
              message: `Selecione o produto. Produto: ${index + 1}`,
              duration: 3000,
              type: 'error',
            })
            validatedForm = false
            return
          }
        })

        if (!validatedForm) {
          return
        }

        if (
          this.$refs.transactionForm &&
          typeof this.$refs.transactionForm.validateBookingProducts ===
            'function' &&
          !this.$refs.transactionForm.validateBookingProducts()
        ) {
          return
        }

        if (
          this.$refs.transactionForm &&
          typeof this.$refs.transactionForm.releaseUncommittedPendingAmounts ===
            'function'
        ) {
          this.$refs.transactionForm.releaseUncommittedPendingAmounts()
        }

        this.transaction.payments.forEach((payment, index) => {
          if (Number(payment.value) > 0) {
            if (!payment.date) {
              this.$notify({
                message: `Selecione a data de pagamento. Pagamento: R$${Number(
                  payment.value
                )
                  .toFixed(2)
                  .replace('.', ',')}`,
                duration: 3000,
                type: 'error',
              })
              validatedForm = false
              return
            }

            if (Number(payment.payment_method.index) == 0) {
              this.$notify({
                message: `Selecione a forma de pagamento. Pagamento: R$${Number(
                  payment.value
                )
                  .toFixed(2)
                  .replace('.', ',')}`,
                duration: 3000,
                type: 'error',
              })
              validatedForm = false
              return
            }

            // value is zero
          } else {
            if (payment.date && Number(payment.payment_method.index) != 0) {
              this.$notify({
                message: `insira um valor maior que zero. Pagamento: R$${Number(
                  payment.value
                )
                  .toFixed(2)
                  .replace('.', ',')}`,
                duration: 3000,
                type: 'error',
              })
              validatedForm = false
              return
            }
          }
        })

        if (!this.transaction.general.date) {
          this.$notify({
            message: `Selecione a data da conta!`,
            duration: 3000,
            type: 'error',
          })
          validatedForm = false
          return
        }

        if (
          this.$refs.transactionForm &&
          this.$refs.transactionForm.syncTransactionLabel
        ) {
          this.$refs.transactionForm.syncTransactionLabel()
        }

        if (!validatedForm) {
          return
        }

        this.isLoading = true

        if (
          this.$refs.transactionForm &&
          typeof this.$refs.transactionForm.releaseBookingsLeavingAccount ===
            'function'
        ) {
          const released =
            await this.$refs.transactionForm.releaseBookingsLeavingAccount()
          if (!released) {
            this.isLoading = false
            return
          }
        }

        this.transaction.type = 1

        this.transaction.payments.forEach((payment, index) => {
          if (payment.date == '') {
            payment.payment_method.index = 0
            payment.payment_method.name = 'Pendente'
            payment.date = moment().format('YYYY-MM-DD')
          }
          if (payment.payment_types && payment.payment_types.length != 0) {
            if (!payment.payment_link) {
              payment.payment_link = {}
            }
            payment.payment_link.payment_types = JSON.parse(
              JSON.stringify(payment.payment_types)
            )
            delete payment.payment_types
          }
          if (
            !payment.date &&
            Number(payment.payment_method.index) == 0 &&
            payment.value == 0
          ) {
            this.transaction.payments[index].date =
              this.transaction.general.date
          }
        })

        this.transaction.products.forEach((product, index) => {
          try {
            product.booking.payments[0].transaction_id =
              this.transaction.general.id || null
            product.booking.payments[0].payment_value = product.item.price
            product.booking.payments[0].payment_method = 'cod'
          } catch (error) {}
        })

        await this.createTransaction(this.transaction)
          .then((response) => {
            sessionStorage.removeItem('stored_transaction')

            let message = 'Entrada financeira '
            if (this.transaction.general.id == null) {
              message += 'criada!'
            } else {
              message += 'atualizada!'
            }

            this.$notify({
              title: this.transaction.general.label,
              message: message,
              duration: 6000,
              type: 'success',
            })
            const saved = Array.isArray(response) ? response[0] : response
            const savedId =
              (saved && saved.general && saved.general.id) ||
              (this.transaction.general && this.transaction.general.id)

            console.log('savedId', savedId, id, reopenTransactionID)
            if (reopenTransactionID) {
              console.log('loadTransactions', {
                id: savedId || id,
                reopenTransactionID: reopenTransactionID,
              })
              this.$emit('loadTransactions', {
                id: savedId || id,
                reopenTransactionID: reopenTransactionID,
              })
            } else {
              this.$emit('loadTransactions')
            }
              this.closeTransactionModal()
          })
          .catch((err) => {})
          .finally(() => {
            this.isLoading = false
          })
      }
    },

    handleDisabledSaveButton(value) {
      this.disabledSaveButton = value
    },

    closeTransactionModal() {
      this.$emit('closeTransactionModal', false)
    },

    closeQuoteDropdown() {
      this.quoteDropdownOpen = false
    },

    openImportBookingModal() {
      this.closeQuoteDropdown()
      const form = this.$refs.transactionForm
      if (form && typeof form.openImportBookingModal === 'function') {
        form.openImportBookingModal()
      }
    },

    openQuoteDropdown() {
      this.quoteDropdownOpen = true
      if (!this.quoteLeads.length && !this.quoteLoading) {
        this.loadQuoteLeads()
      }
    },

    async loadQuoteLeads() {
      this.quoteLoading = true
      try {
        const response = await nodeService.getLeads()
        this.quoteLeads = (response.data || []).map((lead) => ({
          ...lead,
          searchText: [
            lead.booking_code,
            lead.product_place,
            lead.status,
            lead.channel,
            lead.hash,
            lead.observation,
            lead.date,
            lead.time,
            lead.people,
            lead.costumer && lead.costumer.name,
            ...(lead.items || []).map((item) => `${item.title} ${item.label}`),
          ].join(' '),
        }))
      } catch (error) {
        this.quoteLeads = []
        this.$notify({
          message: 'Erro ao carregar reservas disponíveis.',
          duration: 3000,
          type: 'error',
        })
      } finally {
        this.quoteLoading = false
      }
    },

    selectQuoteLead(lead) {
      const form = this.$refs.transactionForm
      if (form && typeof form.importBookingFromLead === 'function') {
        form.importBookingFromLead(lead)
      }
      this.quoteSearch = ''
      this.quoteDropdownOpen = false
    },

    quoteResponsibleLabel(lead) {
      const name =
        lead.costumer && lead.costumer.name ? lead.costumer.name : 'Responsável'
      const people = lead.people ? Number(lead.people) : 0
      if (people > 0) {
        return `${name} (grupo de ${people} ${
          people == 1 ? 'pessoa' : 'pessoas'
        })`
      }
      return name
    },

    formatQuoteDate(date) {
      return date ? moment(date).format('DD/MM/YYYY') : ''
    },

    formatQuoteCurrency(value) {
      return Number(value).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      })
    },

    getQuoteLeadTotal(lead) {
      if (!lead.items || !lead.items.length) return 0
      return lead.items.reduce((total, item) => {
        const price = Number(item.unit_price) - Number(item.unit_discount || 0)
        return total + Number(item.quantity) * price
      }, 0)
    },

    quoteStatusVariant(status) {
      const variants = {
        PENDING: 'warning',
        CONFIRMED: 'success',
        CANCELLED: 'danger',
      }
      return variants[status] || 'secondary'
    },

    transactionHasChanged(value) {
      this.changedTransaction = value
    },

    confirmDelete() {
      if (!this.closedTransaction) {
        swal
          .fire({
            title: `Deseja excluir a conta #${this.transaction.general.id} ?`,
            text: `Transação ${this.transaction.general.label}`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sim, excluir',
            confirmButtonColor: '#D93051',
            cancelButtonText: 'Não',
            reverseButtons: true,
            cancelButtonColor: 'secondary',
            // type: 'default'
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              this.transaction.type = '1'
              await this.deleteTransaction(this.transaction)
              this.quoteSearch = ''
              this.defaultCloseModal(
                'Conta excluída!',
                'success',
                'loadTransactions'
              )
            }
          })
      }
    },

    checkCloseTransaction() {
      if (!this.transaction.general.open && this.transaction.general.id) {
        if (this.disabledSaveButton || this.changedTransaction) {
          this.transaction.general.open = false
          this.$notify({
            message: `Não é possível fechar a transação financeira. Verifique os campos.`,
            duration: 3000,
            type: 'error',
          })
        } else {
          this.transaction.general.open = true
          this.confirmCloseTransaction()
        }
      }
    },

    confirmCloseTransaction() {
      swal
        .fire({
          title: `Deseja fechar a conta #${this.transaction.general.id} ?`,
          text: `Transação ${this.transaction.general.label}`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Fechar a conta',
          confirmButtonColor: '#D93051;',
          cancelButtonText: 'Cancelar',
          reverseButtons: true,
          cancelButtonColor: 'secondary',
          // type: 'default'
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            this.transaction.general.open = false

            await this.closeTransaction(this.transaction)
            this.defaultCloseModal(
              'Conta fechada!',
              'success',
              'loadTransactions'
            )
          }
        })
    },

    defaultCloseModal(message, type, emit) {
      this.$notify({
        title:
          'Conta #' +
          this.transaction.general.id +
          ' :: ' +
          this.transaction.general.label,
        message: message,
        duration: 6000,
        type: type,
      })
      this.$emit(emit)
      this.closeTransactionModal()
    },

    confirmTransmission() {
      swal
        .fire({
          title: `Deseja transmitir a conta #${this.transaction.general.id}?`,
          text: `Após a ação não será possível modificar os dados da conta!`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Transmitir',
          confirmButtonColor: '#D93051;',
          cancelButtonText: 'Cancelar',
          reverseButtons: true,
          cancelButtonColor: 'secondary',
          // type: 'default'
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await this.sendTransaction(this.transaction).then(() => {
              this.defaultCloseModal(
                'Conta transmitida!',
                'success',
                'loadTransactions'
              )
            })
          }
        })
    },
  },

  async mounted() {
    const allPaymentsClosed = this.transaction.payments.every(function (
      value,
      index
    ) {
      return !value.open
    })
    if (!this.transaction.payments[0].time) {
      this.transaction.payments[0].time = ''
    }
    this.transaction.general.open = !allPaymentsClosed

    sessionStorage.setItem(
      'stored_transaction',
      JSON.stringify(this.transaction)
    )

    const PLACE_UUID = this.place.uuid || this.place.janooUserUuid
    await this.fetchPOIs({ PLACE_UUID: PLACE_UUID, PRODUCT_UUID: '' })
    if (this.transaction.general.id == null) {
      this.loadQuoteLeads()
    }

  },
}
</script>

<style>
.transaction-account-modal {
  overflow: hidden;
}

.transaction-account-modal .modal-dialog {
  height: 95vh;
  height: 95dvh;
  max-height: 95vh;
  max-height: 95dvh;
  margin-top: 2.5vh;
  margin-bottom: 2.5vh;
  margin-top: 2.5dvh;
  margin-bottom: 2.5dvh;
  display: flex;
}

@media (max-width: 991.98px) {
  .transaction-account-modal .modal-dialog {
    max-width: none;
    width: calc(100% - 16px);
    margin-left: 8px;
    margin-right: 8px;
  }

  .transaction-modal-import {
    flex-wrap: wrap;
  }

  .transaction-modal-import-field {
    min-width: 0;
    width: 100%;
  }

  .transaction-modal-quote-list {
    width: min(420px, calc(100vw - 32px));
  }
}

@media (max-width: 575.98px) {
  .transaction-account-modal .modal-dialog {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    height: 100vh;
    height: 100dvh;
    max-height: 100vh;
    max-height: 100dvh;
    margin-top: 0;
    margin-bottom: 0;
  }

  .transaction-account-modal .modal-content {
    border-radius: 0;
    min-height: 100%;
  }
}

.transaction-account-modal .modal-header.transaction-modal-header {
  flex: 0 0 auto;
  position: relative;
  z-index: 2;
  overflow: visible;
}

.transaction-account-modal-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

.transaction-account-modal-footer {
  flex: 0 0 auto;
  background: #fff;
}

.modal-add-footer {
  display: flex;
}

.transaction-modal-header {
  overflow: visible;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 4px;
}

.transaction-modal-close {
  margin-left: 12px;
  margin-top: 2px;
  opacity: 1;
}

.transaction-modal-header-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  min-width: 72px;
}

.transaction-modal-import {
  display: flex;
  align-items: center;
  gap: 10px;
}

.transaction-modal-import-search {
  position: relative;
}

.transaction-modal-see-all {
  border: 0;
  background: transparent;
  color: #12576e;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  padding: 6px 4px;
}

.transaction-modal-see-all:hover {
  text-decoration: underline;
}

.transaction-modal-description {
  font-size: 16px;
  color: #505050;
  font-weight: 500;
  margin-top: 10px;
  margin-bottom: 20px;
}

.transaction-modal-import-label {
  font-weight: 600;
  white-space: nowrap;
}

.transaction-modal-import-field {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 260px;
  padding: 6px 12px;
  border: 1px solid #d0d0d0;
  border-radius: 8px;
  background: #fff;
}

.transaction-modal-import-field i {
  color: #8a8a8a;
  font-size: 12px;
}

.transaction-modal-import-field input {
  border: 0;
  outline: none;
  width: 100%;
  background: transparent;
}

.transaction-modal-quote-list {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: 1080;
  width: 420px;
  max-height: 360px;
  overflow-y: auto;
  padding: 8px;
  background: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.14), 0 2px 6px rgba(0, 0, 0, 0.08);
}

.transaction-modal-quote-empty {
  padding: 12px;
  color: #8a8a8a;
  font-size: 13px;
}

.transaction-modal-quote-card {
  display: block;
  width: 100%;
  margin-bottom: 8px;
  padding: 18px 15px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fff;
  text-align: left;
  cursor: pointer;
}

.transaction-modal-quote-card:last-child {
  margin-bottom: 0;
}

.transaction-modal-quote-card:hover {
  border-color: #12576e;
}

.transaction-modal-quote-card-top {
  display: flex;
  align-items: center;
  gap: 6px;
}

.transaction-modal-quote-code {
  color: #12576e;
  font-weight: 700;
}

.transaction-modal-quote-title {
  margin-top: 10px;
  margin-bottom: 10px;
  font-weight: 600;
}

.transaction-modal-quote-meta {
  margin-top: 2px;
  color: #6c6c6c;
}

.transaction-modal-close:hover {
  opacity: 1;
}

.transaction-modal-close:hover path {
  stroke: #5a5a5a;
}

/* .progress-bar {
        background-color: #D9D9D9;
        width: auto;
        height: 10px;
        border-radius: 10px;
        margin-bottom: 15px;
   } */

.progress-bar-inside {
  background-color: #a7aa37;
  width: auto;
  height: 10px;
  border-radius: 10px;
}

.switch-wrapper {
  display: flex;
  align-items: center;
}

.switch-container {
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
}

.switch {
  width: 40px;
  height: 20px;
  position: relative;
  appearance: none;
  background: #ccc;
  border-radius: 20px;
  outline: none;
  cursor: pointer;
  transition: background 0.3s;
}

.switch:checked {
  background: #22a06b;
}

.switch:before {
  content: '';
  position: absolute;
  width: 18px;
  height: 18px;
  background: white;
  border-radius: 50%;
  top: 1px;
  left: 2px;
  transition: 0.3s;
}

.switch:checked:before {
  left: 20px;
}

.status-label {
  margin-left: 10px;
  font-weight: 600;
  color: #1b1b1b;
}

.button-habilitar {
  display: none;
}
</style>
